<div dropdown class="btn-group">
  <button
    dropdownToggle
    type="button"
    class="btn btn-lg btn-link"
    title="Open app navigation"
    id="single-button"
  >
    <img [src]="'../assets/images/menu.svg'" class="menu-icon" alt="Menu" />
  </button>
  <ul
    *dropdownMenu
    class="dropdown-menu dropdown-menu-right"
    role="menu"
    aria-labelledby="single-button"
  >
    <li
      role="menuitem"
      *ngFor="let dropdownItem of dropdownItems"
      [attr.data-id]="dropdownItem.dataId"
    >
      <ng-container
        *ngIf="
          canShowDropdownItem(dropdownItem) && dropdownItem.title != 'Live Chat'
        "
      >
        <a
          *ngIf="dropdownItem.isRouterlink"
          [attr.target]="dropdownItem.openInNewTab ? '_blank' : null"
          [routerLink]="dropdownItem.href"
          [title]="dropdownItem.title"
        >
          {{ dropdownItem.title }}
        </a>
        <a
          *ngIf="!dropdownItem.isRouterlink"
          [attr.target]="dropdownItem.openInNewTab ? '_blank' : null"
          [attr.href]="
            dropdownItem.href
              ? dropdownItem.href
              : dropdownItem.ninthGradeSuccessUrl
              ? dropdownItem.ninthGradeSuccessUrl
              : null
          "
          (click)="clickLink(dropdownItem)"
          [title]="dropdownItem.title"
        >
          {{ dropdownItem.title }}
        </a>
      </ng-container>
      <ng-container *ngIf="dropdownItem.title == 'Live Chat'">
        <live-chat
          data-cy="NavLiveChat"
          [rgpTenantId]="rgpTenantId"
          class="live-chat"
        ></live-chat>
      </ng-container>
    </li>
  </ul>
</div>
